import { useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  AssignmentPreviewJobFragmentGQLType,
  useGetAssignmentPreviewJobsQuery,
} from 'types/dashboard-core-gqlTypes.generated.d';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { useLoanProductCreditFacilityGroupContext } from 'packages/loanProduct/hooks/LoanProductCreditFacilityGroupingProvider';

export const usePollPreviewGenerationJobs = ({
  organizationId,
  reportingDate,
  fileVersion,
}: {
  organizationId: string;
  reportingDate?: Util.FullDateStr;
  fileVersion?: number;
}) => {
  const toast = useToast();
  const { lpToCfEntityGrouping } = useLoanProductCreditFacilityGroupContext();

  const [previewJobs, setPreviewJobs] = useState<
    AssignmentPreviewJobFragmentGQLType[]
  >();

  const { data, startPolling, stopPolling } = useGetAssignmentPreviewJobsQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    fetchPolicy: 'no-cache',
    variables: {
      loanProductIds:
        lpToCfEntityGrouping?.loanProducts.map(({ id }) => id) ?? [],
      organizationId,
      reportingDate,
      fileVersion,
    },
  });

  useEffect(() => {
    startPolling(5000);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  useEffect(() => {
    setPreviewJobs(data?.assignmentPreviewJobs ?? []);
  }, [data]);

  return {
    previewJobs,
  };
};
